var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"schedule-names mb-0 text-secondary"},[_vm._v("\n    "+_vm._s(_vm.schedule_names)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }